<template>
  <div class="all">
    <div class="content">
      <div><span>新闻</span><span>资讯</span></div>
      <div class="separation"></div>
      <div class="en-news">NEWS INFORMATION</div>
    </div>
    <div class="body">
      <div class="news-link">
        <div
          class="items"
          v-for="item in records"
          :key="item.value"
          @click="toNewPage(item.link)"
        >
          <div
            :style="{
              backgroundImage: 'url(' + base_url + item.frontCover + ')',
            }"
          ></div>
          <p class="title">{{ item.title }}</p>
          <div class="string">
            <i class="el-icon-time"></i> {{ item.updateTime }}
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      style="background-color: #fbfbfb"
    >
    </el-pagination>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  created() {
    const data = {
      pageNumber: 1,
      pageSize: 6,
    };
    Axios.post("/apis/news/getPublisedPage", JSON.stringify(data), {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        this.records = res.data.data.records;
        this.total = res.data.data.pages;
        console.log(this.total);
      })
      .catch((err) => console.log(err));
  },
  mounted() {
    console.log(this.records);
  },

  data() {
    return {
      total: 10,
      currentPage: 1,
      pageSize: 10,
      records: "",
      base_url: "",
    };
  },
  methods: {
    handleSizeChange(val) {
      // this.currentPage = val;
      console.log(val);
      console.log(111);
    },
    handleCurrentChange(val) {
      let data = {
        pageNumber: val,
        pageSize: 6,
      };
      Axios.post("/apis/news/getPublisedPage", JSON.stringify(data), {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.records = res.data.data.records;
        })
        .catch((err) => console.log(err));
    },
    toNewPage(value) {
      window.open(value, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 500px;
  background-color: #fff;
  //   margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  div {
    font-size: 34px;
    font-weight: 700;
    span:first-child {
      color: #c30000;
    }
  }
  .en-news {
    color: #545454;
    font-weight: normal;
  }
  .separation {
    width: 68px;
    height: 4px;
    background-color: #c30000;
  }
}
.body {
  background-color: #fbfbfb;
  .news-link {
    width: 1200px;
    height: 1000px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    // justify-content: center;
    margin: 0 auto;

    padding-top: 35px;
    box-sizing: border-box;
    .items {
      width: 400px;
      height: 380px;
      background-color: #fff;
      margin: 10px 0;
      border: 1px solid #dcdcdc;
      padding: 20px;
      box-sizing: border-box;
      div {
        width: 358px;
        height: 200px;
        background-position: center center;
        background-size: cover;
      }
      .title {
        font-size: 28px;
        min-height: 72px;
        color: #333;
        line-height: 36px;
        text-align: left;
        margin-top: 25px;
      }
      .string {
        font-size: 16px;
        color: #ccc;
        margin-left: 5px;
        text-align: left;
        margin-top: 25px;
      }
      .el-pagination .active {
        background: #c30000 !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue